export default __webpack_public_path__ + "static/media/sfp-dpd.a0b608c4.svg";